import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';
import ipTransparentLogo from "../../assets/img/buckzy.jpg";

// ----------------------------------------------------------------------

const Logo = forwardRef(
  ({ disabledLink = false, sx, isFull, showFull = true, theme = null, ...other }, ref) => {
    const logo = (
      <Box
        component="img"
        src={ipTransparentLogo}
        sx={{ width: showFull ? 40 : 220, cursor: 'pointer', ...sx }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
